__turbopack_context__.v({
  "mention-node": "styles-module__0BXGSq__mention-node",
});
